import { SegmentedControl } from '@shinetools/lumen-react'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { ExpertBalanceSheetViewMode } from '../../types/expertBalanceSheetView'

interface ExpertBalanceSheetViewModeToggleProps {
  onViewModeChange: (viewMode: ExpertBalanceSheetViewMode) => void
  viewMode: ExpertBalanceSheetViewMode
}

const isViewMode = (value: string): value is ExpertBalanceSheetViewMode =>
  Object.values<string>(ExpertBalanceSheetViewMode).includes(value)

export const ExpertBalanceSheetViewModeToggle = ({
  onViewModeChange,
  viewMode,
}: ExpertBalanceSheetViewModeToggleProps): ReactElement => {
  const { t } = useTranslation()

  const items = useMemo(
    () => [
      { label: t('expert_balance_sheet.view_mode.summary'), value: ExpertBalanceSheetViewMode.Summary },
      { label: t('expert_balance_sheet.view_mode.detailed'), value: ExpertBalanceSheetViewMode.Detailed },
    ],
    [t],
  )

  const handleValueChange = (value: string) => {
    if (isViewMode(value)) {
      onViewModeChange(value)
    }
  }

  return (
    <SegmentedControl
      aria-label={t('expert_balance_sheet.view_mode.label')}
      items={items}
      onValueChange={handleValueChange}
      value={viewMode}
    />
  )
}
